var _path, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewTof(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 42,
    viewBox: "0 0 84 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54545 11.3941V8.89414H19V11.3941H11.6818V32.1669H8.86364V11.3941H1.54545ZM41.217 20.5305C41.217 22.9851 40.7739 25.1063 39.8875 26.8941C39.0011 28.682 37.7852 30.0608 36.2398 31.0305C34.6943 32.0002 32.9292 32.4851 30.9443 32.4851C28.9595 32.4851 27.1943 32.0002 25.6489 31.0305C24.1034 30.0608 22.8875 28.682 22.0011 26.8941C21.1148 25.1063 20.6716 22.9851 20.6716 20.5305C20.6716 18.076 21.1148 15.9547 22.0011 14.1669C22.8875 12.379 24.1034 11.0002 25.6489 10.0305C27.1943 9.06081 28.9595 8.57596 30.9443 8.57596C32.9292 8.57596 34.6943 9.06081 36.2398 10.0305C37.7852 11.0002 39.0011 12.379 39.8875 14.1669C40.7739 15.9547 41.217 18.076 41.217 20.5305ZM38.4898 20.5305C38.4898 18.5154 38.1527 16.8146 37.4784 15.4282C36.8117 14.0419 35.9064 12.9926 34.7625 12.2805C33.6261 11.5684 32.3534 11.2123 30.9443 11.2123C29.5352 11.2123 28.2587 11.5684 27.1148 12.2805C25.9784 12.9926 25.0731 14.0419 24.3989 15.4282C23.7322 16.8146 23.3989 18.5154 23.3989 20.5305C23.3989 22.5457 23.7322 24.2464 24.3989 25.6328C25.0731 27.0191 25.9784 28.0684 27.1148 28.7805C28.2587 29.4926 29.5352 29.8487 30.9443 29.8487C32.3534 29.8487 33.6261 29.4926 34.7625 28.7805C35.9064 28.0684 36.8117 27.0191 37.4784 25.6328C38.1527 24.2464 38.4898 22.5457 38.4898 20.5305ZM45.1557 32.1669V8.89414H59.1102V11.3941H47.9739V19.2578H58.0648V21.7578H47.9739V32.1669H45.1557Z",
    fill: "#23AF91"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_457_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4219 11C67.4219 10.4477 67.8696 10 68.4219 10H72.4184C72.9707 10 73.4184 10.4477 73.4184 11V14.9965C73.4184 15.5488 72.9707 15.9965 72.4184 15.9965H68.4219C67.8696 15.9965 67.4219 15.5488 67.4219 14.9965V11Z",
    fill: "#23AF91"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_457_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4219 19.0013C67.4219 18.4491 67.8696 18.0013 68.4219 18.0013H72.4184C72.9707 18.0013 73.4184 18.4491 73.4184 19.0013V22.9979C73.4184 23.5502 72.9707 23.9979 72.4184 23.9979H68.4219C67.8696 23.9979 67.4219 23.5502 67.4219 22.9979V19.0013Z",
    fill: "#8E7CFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_457_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4219 27.0028C67.4219 26.4505 67.8696 26.0028 68.4219 26.0028H72.4184C72.9707 26.0028 73.4184 26.4505 73.4184 27.0028V30.9994C73.4184 31.5516 72.9707 31.9994 72.4184 31.9994H68.4219C67.8696 31.9994 67.4219 31.5516 67.4219 30.9994V27.0028Z",
    fill: "#FF5E66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_457_208",
    x: 57.4219,
    y: 0,
    width: 25.9961,
    height: 25.9966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.686275 0 0 0 0 0.568627 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_457_208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_457_208",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_457_208",
    x: 57.4219,
    y: 8.00134,
    width: 25.9961,
    height: 25.9966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.556863 0 0 0 0 0.486275 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_457_208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_457_208",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_457_208",
    x: 57.4219,
    y: 16.0028,
    width: 25.9961,
    height: 25.9966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.4 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_457_208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_457_208",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTof);
export default __webpack_public_path__ + "static/media/new_tof.a1769f30e1757eec1a7508141e757848.svg";
export { ForwardRef as ReactComponent };